/* tslint:disable:no-var-requires */
// require jquery
import '@/libs/jquery/index'
import '@/libs/jquery/validation'
import '@/libs/jquery_ujs/index'

import URI from 'urijs'

// require jquery.remotipart
import 'jquery-remotipart/src/jquery.remotipart.js'

// require unorm/lib/unorm.js
import 'unorm'

// require cocoon
require('cocoon-js')

window.URI = URI
/* tslint:enable:no-var-requires */
